export * from './lib/legal.module';
export * from './lib/services/legal.service';
